//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { theme } from '@bvengineering/unison-core';

import { DEFAULT_PAGE_HEADER_TOTAL_HEIGHT } from '@components/organisms/page-header/PageHeader';
import {
  SIDEBAR_WIDTH,
  TOP_NAVIGATION_HEIGHT,
} from '@universal-scheduling/components/calendar/UniversalCalendarConstants';
import { pxStrToNum } from '@utils/styleUtils';

// We want to show 5 full rows of existing posts in the feed preview,
// meaning we need between 15-17 to fill out the rows.
export const FEED_PREVIEW_LIVE_POST_LIMIT = 17;

export const SEARCH_DAYS_LIMIT = 14;

export const FILENAME_DATE_FORMAT = 'YYMMDD';

export const FEED_PREVIEW_NUM_GRID_ITEMS = 3;
export const FEED_PREVIEW_WIDTH = 302;

// when the feed preview has a vertical scrollbar
export const FEED_PREVIEW_MAX_WIDTH = 320;
export const FEED_PREVIEW_GRID_GAP = 2;
export const FEED_PREVIEW_PADDING = theme.spacings[3];
export const FEED_PREVIEW_CONTENT_BORDER_WIDTH = theme.borderWidths[1];
export const FEED_PREVIEW_OFFSET = FEED_PREVIEW_MAX_WIDTH + SIDEBAR_WIDTH;
export const FEED_PREVIEW_TOP_OFFSET =
  DEFAULT_PAGE_HEADER_TOTAL_HEIGHT + TOP_NAVIGATION_HEIGHT;

export const FEED_PREVIEW_ITEM_WIDTH =
  (FEED_PREVIEW_WIDTH -
    pxStrToNum(FEED_PREVIEW_PADDING) * 2 -
    FEED_PREVIEW_GRID_GAP * (FEED_PREVIEW_NUM_GRID_ITEMS - 1) -
    pxStrToNum(FEED_PREVIEW_CONTENT_BORDER_WIDTH) * 2) /
  FEED_PREVIEW_NUM_GRID_ITEMS;

export const FEED_PREVIEW_ITEM_HEIGHT = 1.25 * FEED_PREVIEW_ITEM_WIDTH;

// for live posts or scheduled posts that can't be dragged
export const FEED_PREVIEW_ITEM_LOWERED_OPACITY = 0.7;

export const ScheduleFeedPreviewZIndex = {
  DragLayer: 30,
  PastDueBadge: 10,
  ScheduledTimeIcon: 11,
  ScheduledTimeTooltip: 12,
} as const;

export const FEED_PREVIEW_INFO_ALERT_DISMISS_DAYS = 180;
